<template>
  <div class="home content-padding">
    <div class="home-header">
      <h2>Список домов</h2>
      <div class="home-header-links">
        <router-link :to="{name: 'AddHouse'}"><span class="ic-add"></span>Добавить дом</router-link>
        <router-link :to="{name: 'Report'}"><span class="ic-add"></span>Создать отчет</router-link>
      </div>
    </div>

    <Ymap :markers="coordinatesList" class="home-map"></Ymap>

    <Loader v-if="listLoadingStatus"/>
    <div class="houses-not-found" v-else-if="housesList.length === 0">Дома не найдены</div>

    <div v-else>
      <table-common class="houses-table-row" :rows="housesList" :header="header">
        <template v-slot:body="{col}">
          <div class="col-lg-55 col-12">
            <router-link :to="{name: 'HouseElements', params: {houseId: col.id}}" v-html="col.house.address">
            </router-link>
          </div>
          <div class="col-lg-35 col-12" v-html="col.kadastr"></div>
          <div class="col-lg-2 col-10">{{ col.year }}</div>
          <div class="col-lg-1 col-2 text-end buttons">
            <router-link class="btn" :to="{name: 'EditHouse', params: {houseId: col.id}}">
              <span class="ic-edit"></span>
            </router-link>
            <button @click="showDeleteHouseModal(col.links)" class="btn">
              <span class="ic-trash"></span>
            </button>
          </div>
        </template>
      </table-common>

      <div class="after-houses-list">
        <div v-if="paginator.pages.length > 1" class="houses-paginator">
          <button class="btn"
                  @click="changePage(currentPage - 1)"
                  :disabled="currentPage === paginator.pages[0]"
          ><span class="ic-arrow-left"></span></button>

          <button v-for="page in paginator.pages"
                  :key="page"
                  @click="changePage(page)"
                  class="paginator-number btn"
                  :disabled="typeof page !== 'number' || page === currentPage"
                  :class="{current: page === currentPage}">
            <span>{{ page }}</span>
          </button>
          <button class="btn"
                  @click="changePage(currentPage + 1)"
                  :disabled="currentPage === paginator.pages[paginator.pages.length - 1]"
          ><span class="ic-arrow-right"></span></button>

        </div>

        <div class="count-houses-in-page">
          <drop-down-select :options="countHousesOnPageValues" v-model="countHousesOnPage"></drop-down-select>
        </div>
      </div>


    </div>


  </div>
  <Modal v-model="showModal" class="modal-sm">
    <template v-slot:title>
      Удалить адрес
    </template>
    <template v-slot:body>
      <div class="position-relative">
        <transition name="fade">
          <div v-if="isDeleteHouseLoading" class="common-shadow-loader">
            <Loader/>
          </div>
        </transition>
        <div class="delete-buttons">
          <button class="btn btn-primary modal-btn" @click="clickDeleteHouse">Да</button>
          <button class="btn btn-primary modal-btn" @click="showModal = false">Нет</button>
        </div>
      </div>
    </template>
  </Modal>

</template>

<script>
import UseHousesList from "@/composables/crudHouse/UseHousesList"
import Loader from "@/components/common/Loader";
import Ymap from "@/components/common/Ymap";
import Modal from "@/components/common/Modal";
import TableCommon from "@/components/common/TableCommon";
import DropDownSelect from "@/components/common/DropDownSelect";

export default {
  name: 'Home',
  components: {DropDownSelect, TableCommon, Modal, Ymap, Loader},
  setup() {
    return {
      ...UseHousesList()
    }
  },
  data() {
    return {
      selectedDeleteItemLink: undefined,
      showModal: false,
      header: [
        {name: 'Адрес', width: 55},
        {name: 'Кадастровый номер', width: 35},
        {name: 'Год постройки', width: 2},
        {name: '', width: 1},
      ]
    }
  },
  methods: {
    showDeleteHouseModal(links) {
      this.showModal = true
      this.selectedDeleteItemLink = links.find(i => i.rel === 'passport' && i.action === 'HEAD').href
    },

    clickDeleteHouse() {
      this.deleteHouse(this.selectedDeleteItemLink)
        .then(() => {
          this.showModal = false
        })
    }
  },
  watch: {
    '$route.query.search': {
      handler: function () {
        if (this.$route.name === 'Home') {
          this.reloadDataByRouteQuery()
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  .home-map {
    min-height: 400px;
    margin: 2rem 0;
  }

  a:not(.btn) {
    text-decoration: none;
    color: #0468ff;

    &:hover {
      color: #dc5454;
    }
  }

  .houses-not-found {
    text-align: center;
    padding: 10px 0;
  }

  .text-end {
    .btn {
      padding: 0;
    }
  }

  .load-more-houses {
    display: flex;
    justify-content: center;
    align-items: center;

    &-button {
      color: #0468ff;
      text-decoration: underline;
    }
  }

  .home-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    &-links {
      display: flex;
      flex-direction: row;

      a {
        display: flex;
        align-items: center;

        color: var(--common-text-color);

        &:first-child {
          margin-right: .9em;
        }

        span {
          color: var(--common-button);
          margin-right: .4em;
        }
      }
    }
  }

  .houses-table-row {
    div {
      text-align: center;
      position: relative;

      &:nth-last-child(n+3):after {
        content: '';
        position: absolute;
        right: 0;
        top: calc(50% - .5rem);
        width: 1px;
        height: 1rem;
        background: var(--common-text);
      }

      &:first-child {
        text-align: left;
      }
    }


    .buttons {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;

      a span, button span {
        font-size: 1.1rem;
        margin-left: .2rem;
      }

    }
  }

  .after-houses-list {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    width: 100%;

    .count-houses-in-page {
      min-width: 85px;
      margin-left: 1em;
    }

    .houses-paginator {
      font-size: var(--main-font-size-text);
      display: flex;
      align-items: center;
      background: var(--common-table-row-background);
      border-radius: 20px;
      padding: .4rem;
      width: min-content;
      flex-direction: row;
      justify-content: flex-end;

      .btn {
        margin: 0 .5rem;
        padding: 0;

        &:not(.current) {
          cursor: pointer;
          color: var(--default-icon-color);
          transition: 200ms;

          &:hover {
            color: var(--common-button);
          }
        }

        &.current {
          color: var(--common-button);

          &:disabled {
            opacity: 1;
          }
        }

        &:disabled {
          background-color: transparent;
          border-color: transparent;
        }
      }
    }
  }
}

.delete-buttons {
  display: flex;
  flex-direction: column;

  .modal-btn {
    margin-top: 5px;
    width: 100%;
  }
}

.home-search {
  margin: 40px 0;
}
@media (max-width: 992px) {

  .home .houses-table-row .row div {
    text-align: left;

    &:after {
      background-color: transparent;
    }

  }

}

@media (max-width: 600px) {
  .home {

    .home-map {
      min-height: 300px;
      margin: 1em 0;
    }

    .home-header {
      flex-direction: column;
      align-items: flex-start;

      .home-header-links {
        flex-direction: column;
      }
    }

    .after-houses-list {
      flex-direction: column;

      div:nth-child(2) {
        margin-top: 1em;
      }
    }

  }


}
</style>
